import React, { useEffect, useState } from 'react';
import { useLanguage } from '../../../context/language';
import { getStrLang } from '../../Translate';
import 'jquery-ui-dist/jquery-ui';
import Slider from '@material-ui/core/Slider';
import { IoChevronBackOutline } from 'react-icons/io5';
import { mascaraValorEmReal, mascaraStringToDouble } from '../../../util/ValidaId';
import PixIcon from '../../../assets/logo-pix.png';
import PixIconWhite from '../../../assets/logo-pix-white.png';
import BoletoIcon from '../../../assets/logo-boleto.png';
import BoletoIconWhite from '../../../assets/logo-boleto-white.png';

const PixSlide = (props) => {
    //Chamada para as variáveis e funções do Context
    const { translate, lang } = useLanguage();
    const montante = parseFloat(((((sessionStorage.getItem("conv_amount")).replace("R$", "")).replace(".", "")).replace(",", ".")), 2);
    //Porcentagem de split
    const [percent, setPercent] = useState(50);
    const [valueSlider, setValueSlider] = useState(50);
    const [editandoValorInput, setEditandoValorInput] = useState(false);

    function handleChange(event) {
        const { value, name } = event.target;
        setEditandoValorInput(true);
        let valorFloat = mascaraStringToDouble(value);
        let novoValorSlide = (valorFloat / montante) * 100
        if (name === "valorOpcao1") {
            if (mascaraStringToDouble(value) < 0) {
                props.setVspt1(mascaraValorEmReal(String(0)));
                props.setVspt2(mascaraValorEmReal(montante.toFixed(2)));
            } else if (mascaraStringToDouble(value) > montante) {
                props.setVspt1(mascaraValorEmReal(montante.toFixed(2)));
                props.setVspt2(mascaraValorEmReal(String(0)));
            } else {
                props.setVspt1(mascaraValorEmReal(value));
                props.setVspt2(mascaraValorEmReal((montante - mascaraStringToDouble(value)).toFixed(2)));
            }
            setValueSlider(100 - Math.round(novoValorSlide));
        } else {
            if (mascaraStringToDouble(value) < 0) {
                props.setVspt2(mascaraValorEmReal(String(0)));
                props.setVspt1(mascaraValorEmReal(montante.toFixed(2)));
            } else if (mascaraStringToDouble(value) > montante) {
                props.setVspt2(mascaraValorEmReal(montante.toFixed(2)));
                props.setVspt1(mascaraValorEmReal(String(0)));
            } else {
                props.setVspt2(mascaraValorEmReal(value));
                props.setVspt1(mascaraValorEmReal((montante - mascaraStringToDouble(value)).toFixed(2)));
            }
            setValueSlider(Math.round(novoValorSlide));
        }
    }

    //Traduz o texto na tela quando mudado o idioma pelo usuário
    useEffect(() => {
        translate();
    }, [translate]);

    useEffect(() => {
        splitPayment();
    }, [percent]);

    function valuetext(value) {
        if (value !== percent) {
            setPercent(value);
            if (!editandoValorInput) {
                splitPayment();
            }
        }
    }

    const marks = [
        {
            value: 0,
            label: '100/0',
        },
        {
            value: 50,
            label: '50/50',
        },
        {
            value: 100,
            label: '0/100',
        },
    ];

    //Dividir o valor da ordem entre as opções selecionadas:
    function optSplit(op) {

        switch (op) {
            case "p/p":
                props.setSpt1("Pix");
                props.setSpt2("Pix");
                break;
            case "p/b":
                props.setSpt1("Pix");
                props.setSpt2("Boleto");
                sessionStorage.removeItem("infoBilletSplited");
                break;
            case "b/b":
                props.setSpt1("Boleto");
                props.setSpt2("Boleto");
                break;
            default:
                props.setSpt1("Pix");
                props.setSpt2("Pix");
                break;
        }
    }

    function splitPayment() {
        props.setVspt2(mascaraValorEmReal(((montante / 100) * percent).toFixed(2)));
        props.setVspt1(mascaraValorEmReal((montante - ((montante / 100) * percent).toFixed(2)).toFixed(2)));

    }

    function getIconOption(option) {
        switch (option) {
            case "Pix":
                return (<div className='title-option-split-slide'><IconButton texto={"PIX"} src={PixIcon} alt={"Imagem icone pix"} class={"icone-btn-split"} /></div>);
            default:
                return (<div className='title-option-split-slide'><IconButton texto={"BOLETO"} src={BoletoIcon} alt={"Imagem icone pix"} class={"icone-btn-split"} /></div>);
        }
    }

    const IconButton = (props) => {
        return (
            <div className={props.class}>
                <img src={props.src} alt={props.alt} width="22px" height="20px" style={{ marginRight: "0.5em", marginBottom: "0.2em" }} />
            </div>
        )
    }

    return (
        <div className="grup-splited-opt">
            <div className="column-pix-sides">
                <button className="btn-split-pix" onClick={() => props.setTelaPix("default")}><IoChevronBackOutline size={25} /> {getStrLang(lang.nameLang, "btn_voltar")}</button>
            </div>
            <div className="msg-pix">
                <div className="group-slide-split-content">
                    <div className="split-options">
                        {getIconOption(props.spt1)}
                        <input value={props.vSpt1} name="valorOpcao1" onChange={handleChange} type="text" onBlur={() => setEditandoValorInput(false)} />
                    </div>
                    <div className="split-slider" onMouseEnter={() => setEditandoValorInput(false)}>
                        <Slider
                            defaultValue={valueSlider}
                            aria-label="Temperature"
                            value={valueSlider}
                            step={1}
                            marks={marks}
                            min={0}
                            max={100}
                            onClick={() => setEditandoValorInput(false)}
                            style={editandoValorInput ? { display: "flex" } : { display: "none" }}
                        />
                        <Slider
                            defaultValue={percent}
                            getAriaValueText={valuetext}
                            aria-label="Temperature"
                            step={1}
                            marks={marks}
                            min={0}
                            max={100}
                            style={!editandoValorInput ? { display: "flex" } : { display: "none" }}
                        />
                    </div>
                    <div className="split-options">
                        {getIconOption(props.spt2)}
                        <input value={props.vSpt2} name="valorOpcao2" onChange={handleChange} type="text" onBlur={() => setEditandoValorInput(false)} />
                    </div>
                </div>
                <button className="btn-split-processar" onClick={() => {props.setTelaPix("splited")}}>{getStrLang(lang.nameLang, "process_button")}</button>
            </div>
            <div className="column-pix-sides column-justfy-itens-center">
                <div className="group-split-opt">                    
                    <button className="button-split-opt" onClick={() => optSplit("p/p")}><IconButton texto={"PIX"} src={PixIconWhite} alt={"Imagem icone pix"} class={"icone-btn-split"} />/<IconButton texto={"PIX"} src={PixIconWhite} alt={"Imagem icone boleto"} class={"icone-btn-split"} /></button>
                    <button className="button-split-opt" onClick={() => optSplit("p/b")}><IconButton texto={"PIX"} src={PixIconWhite} alt={"Imagem icone pix"} class={"icone-btn-split"} />/<IconButton texto={"BOLETO"} src={BoletoIconWhite} alt={"Imagem icone boleto"} class={"icone-btn-split"} /></button>
                    {/*<button className="button-split-opt" onClick={() => optSplit("b/b")}><IconButton texto={"PIX"} src={PixIcon} alt={"Imagem icone pix"} class={"icone-btn-split"} />/<IconButton texto={"PIX"} src={PixIcon} alt={"Imagem icone pix"} class={"icone-btn-split"} /></button>*/}                    
                </div>
            </div>
        </div>
    )
}

export default PixSlide;